import {
	jobProfileInteractionsDelete,
	jobProfileInteractionsGet,
} from "#job-profile/services/api"
// import { JobProfileInteractionFormDialog } from "./JobProfileInteractionForm"
import JobProfileItem from "../JobProfileItem"
import { JobProfileInteractionFormDialog } from "./JobProfileInteractionForm"

export default function JobProfileInteraction({ profileId, autoFetch, noEdit }) {
	const items = [
		{
			name: "con_quien",
			label: "¿Con Quien?",
		},
		{
			name: "para_que",
			label: "¿Para Qué?",
		},
		{
			name: "tipo",
			label: "Tipo",
		},
	]
	return (
		<JobProfileItem
			key="interaction"
			{...{
				profileId,
				autoFetch,
				tableItems: items,
				apiGet: jobProfileInteractionsGet,
				apiDelete: jobProfileInteractionsDelete,
				name: "",
				messageDelete: (responsibility) => (
					<>
						¿Estas seguro de eliminar la interacción
						<strong> "¿Con quien?" </strong>
						{responsibility.con_quien},<strong> "¿Para que?" </strong>
						{responsibility.para_que}?
					</>
				),
				AddForm: JobProfileInteractionFormDialog,
				noEdit,
			}}
		/>
	)
}
